export default "__VITE_ASSET__jZumwqWF__"